import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Helmet } from "react-helmet";
import { Carousel, Container, Row, Col, Image, Card } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import pressImage from "../Assets/Image/press-shop.jpg";
import flexibleImage from "../Assets/Image/flexible-shop.jpg";
import cncImage from "../Assets/Image/cnc-edm.jpg";
import machiningImage from "../Assets/Image/machining-shop.jpg";
import finishingImage from "../Assets/Image/finishing-machine.jpg";
import busduct1 from "../Assets/Image/busduct1.jpg";
import busduct2 from "../Assets/Image/busduct2.jpg";
import busduct3 from "../Assets/Image/busduct3.jpg";
import busduct4 from "../Assets/Image/busduct4.jpg";
import busduct5 from "../Assets/Image/busduct5.jpg";
import busduct6 from "../Assets/Image/busduct6.jpg";
import copper1 from "../Assets/Image/Molded1.jpeg";
import copper2 from "../Assets/Image/Molded.jpeg";
import copper3 from "../Assets/Image/Molded2.jpeg";
import copper4 from "../Assets/Image/Molded3.jpeg";
import insulator1 from "../Assets/Image/insulator1.jpg";
import insulator2 from "../Assets/Image/insulator2.jpg";
import insulator3 from "../Assets/Image/insulator3.jpg";
import insulator4 from "../Assets/Image/insulator4.jpg";
import steel1 from "../Assets/Image/steel1.jpg";
import steel2 from "../Assets/Images/steel2.jpg";
import steel3 from "../Assets/Image/steel3.jpg";
import steel4 from "../Assets/Image/steel4.jpg";
import steel5 from "../Assets/Image/steel5.jpg";
import img1 from "../Assets/Image/machine1.jpg";
import img2 from "../Assets/Image/machine2.jpg";
import img3 from "../Assets/Image/machine3.jpg";
import img5 from "../Assets/Image/machine5.jpg";
import { Modal, Button } from "react-bootstrap";

const FacilitiesPage = () => {
  const [selectedIndustry, setSelectedIndustry] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = (industry) => {
    setSelectedIndustry(industry);
    setShowModal(true);
  };
  const [selectedItem, setSelectedItem] = useState(null);
  const handleOpen = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const handleClose = () => {
    setSelectedItem(null);
    setShowModal(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedIndustry(null);
  };
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const facilities = [
    {
      id: 1,
      title: "CNC Milling Machines",
      image: machiningImage,
      short: "High-precision CNC and conventional machining setups.",
      details:
        "Supports all types of component machining, surface finishing, and dimension control.Our machining division includes CNC lathes, vertical milling machines, grinding units, and drilling machines to deliver components with micrometer accuracy. From prototyping to full-scale production, the facility handles complex geometries and tight tolerances. Every part goes through rigorous dimensional inspections. We machine copper, aluminum, and mild steel with smooth finishes. The setup supports single-piece customization as well as bulk runs. Tooling is maintained in-house to reduce downtime.",
    },
    {
      id: 2,
      title: " Busbar Fabrication Machines",
      short: "Complete setup for custom busbar manufacturing.",
      details:
        "Handles cutting, punching, and forming of busbars.This facility handles complete busbar manufacturing including CNC cutting, punching, bending, and threading. The machines are compatible with both copper and aluminum in various sizes and finishes. Our team can fabricate complex busbar shapes for panel boards, EV systems, and switchgears. All bending angles are digitally programmed to ensure repeatability. Holes are punched with precision jigs to eliminate alignment issues. Post-fabrication, busbars are cleaned and prepared for sleeving or coating.",
      image: img5,
    },
    {
      id: 2,
      title: " Copper flexible welding machines",
      short:
        "Precision resistance welding for flexible copper and aluminum connectors.",
      details:
        "Our copper flexible welding machines deliver high-quality resistance welds with uniform electrical conductivity. These advanced machines are specially designed for copper and aluminum laminated flexible connectors, ensuring low-resistance joints with minimal deformation. They are ideally suited for assembling battery connectors, braided conductors, and flexible jumpers. Automated setups provide uniform heat distribution and consistent weld depth, while real-time monitoring ensures quality across every production batch. Welding is carried out in a controlled environment to prevent oxidation and guarantee long-lasting performance.",
      image: img2,
    },
    {
      id: 3,
      title: "Busbar / Flexible Sleeving",
      image: flexibleImage,
      short: "Insulation and protection for electrical safety",
      details:
        "Heat-shrink and PVC sleeving are applied to busbars and flexible connectors in a clean and temperature-controlled setup. This enhances insulation, fire resistance, and mechanical protection. The sleeving machines support multi-color, dual-wall, and flame-retardant sleeves. The sleeving is applied post-finishing and checked for adhesion, shrink ratio, and coverage. It ensures compliance with IS and IEC standards. Customized color-coding and printing are available for traceability and circuit identification.Helps in fabricating flexible connectors for transformers and switchgear with thermal expansion handling.",
    },
    {
      id: 4,
      title: "Automatic Foil Cutting Machine",
      short: "Automated cutting of copper and aluminum foils.",
      details:
        "Ensures clean, consistent cuts for laminated connectors.Our foil cutting machines are programmed for speed, accuracy, and repeatability. They handle various thicknesses of copper and aluminum foils with minimal material waste. The cut foils are used in laminated connectors, flexible busbars, and EV battery packs. Machines are equipped with digital blade alignment and automatic feed controls. Scrap recovery systems help us maintain a sustainable process. Every foil batch is barcoded for traceability.",
      image: img1,
    },
    {
      id: 5,
      title: "Press Machines for Stamped Products",
      image: pressImage,
      short: "Precision stamping of metal components.",
      details:
        "Used for metal forming, punching, deep drawing, and other high-force manufacturing operations in our workshop.We operate mechanical and hydraulic presses ranging from 50 to 150 tons, capable of producing stamped components at scale. Dies are designed in-house or provided by the client. These presses produce flat and formed parts like terminal brackets, support plates, and connector blades. Stamping operations are integrated with quality checks, lubrication, and scrap removal. We handle bulk orders efficiently with batch coding and storage. All stamped components go through burr-removal before dispatch.",
    },
    {
      id: 6,
      title: "Silver Brazing Machines",
      short: "High-conductivity metal joining using silver alloy.",
      details:
        "Uniform silver brazing with precise control for low contact resistance.Silver brazing is used to join high-current components where strong bonding and low resistance are essential. We use top-grade silver-based fillers and strictly controlled flame or induction heat. The process results in clean, mechanically strong joints with high thermal and electrical conductivity. It's ideal for switchgear, terminals, and heavy-duty busbars. The work is performed by trained technicians with precision temperature control. Each brazed part is tested for joint integrity and finish quality.",
      image: img3,
    },
    {
      id: 7,
      title: "Clinching Stud/Nut Fixing",
      image: cncImage,
      short: "Non-welded attachment of hardware.",
      details:
        "Studs and nuts are fixed using pneumatic and hydraulic clinching systems that eliminate the need for welding. This ensures stronger attachment and material integrity. Our setup handles different stud/nut sizes and base thicknesses. Clinching allows for quick and clean operations without post-processing. It's ideal for mounting hardware on enclosures and busbars. Each fixture is tested for torque and pull-out strength. The process is clean, fast, and eco-friendly.",
    },

    {
      id: 8,
      title: "Automatic Finishing Machine",
      image: finishingImage,
      short: "Deburring and polishing of components.",
      details:
        "Vital for product surface prep, vibro finishing, and removal of sharp edges or burrs.Our finishing machines include vibro-finishing, belt polishing, and deburring stations. These processes remove burrs, sharp edges, and tool marks from machined or fabricated parts. Finishing improves not only the appearance but also the safety and longevity of electrical components. The system handles copper, aluminum, and other non-ferrous metals. Multiple finishing modes allow us to meet diverse customer specifications. Surface roughness is measured for consistency. The area is dust-controlled for a clean operation.",
    },
  ];

const services = [
  {
    title: "Customized Steel Fasteners For Busduct",
    description: "Robust steel fasteners designed specifically for busduct assemblies.",
    images: [steel1, steel2, steel3, steel4, steel5],
    features: [
      "High-strength steel construction",
      "Custom sizes and threading available",
      "Corrosion-resistant coating",
    ],
    applications: [
      "Busduct assembly connections",
      "Switchgear panel fastening",
      "Control cabinet mounting",
    ],
  },
  {
    title: "Various Molded Components",
    description: "Durable molded components for electrical systems with vibration resistance.",
    images: [copper1, copper2, copper3, copper4],
    features: [
      "Silver-brazed terminations",
      "Flexible design",
      "High thermal performance",
    ],
    applications: [
      "Transformer connections",
      "Industrial motors",
      "Busbar interconnections",
    ],
  },
  {
    title: "Insulator Plates To Busduct",
    description: "High-quality insulator plates providing electrical isolation.",
    images: [insulator1, insulator2, insulator3, insulator4],
    features: [
      "Custom sizes and thicknesses",
      "High dielectric strength",
      "Tested for reliability",
    ],
    applications: [
      "Electrical control panels",
      "Automation lines",
      "Heavy machinery",
    ],
  },
];


  const deltaIndustriesDetails = [
    {
      title: "Switchgear Industry",
      short:
        "Reliable connectors and busbars for safe, efficient power distribution.",
      image: busduct1,
      description:
        "We supply precision-engineered connectors, busbars, and flexible assemblies to the switchgear industry, ensuring safe, reliable, and efficient power distribution. Our components are designed for high-current capacity and durable, maintenance-friendly operation.",
    },
    {
      title: "Transformer Industry",
      short:
        "High-quality copper components for efficient transformer connections.",
      image: busduct2,
      description:
        "Our high-conductivity copper and aluminum components are tailored for transformer manufacturing, enabling efficient electrical connections with minimal losses. We help transformer OEMs deliver robust, long-lasting products for demanding grid and industrial applications.",
    },

    {
      title: "Busduct Industry",
      image: busduct3,
      short: "Custom busbars and joints for secure, modular busduct systems.",
      description:
        "We provide custom busbar assemblies, flexible connectors, and precision-machined joints for busduct systems. Our solutions ensure low-resistance, secure, and safe connections across sections, supporting scalable, modular power distribution networks.",
    },

    {
      title: "Electric Vehicle",
      short: "Advanced connectors and busbars supporting electric mobility.",
      image: busduct4,
      description:
        "Supporting the electric mobility revolution with advanced copper connectors, busbars, and laminated flexibles. Our lightweight, high-conductivity solutions help EV manufacturers deliver reliable, efficient power management systems in vehicles and charging infrastructure.",
    },

    {
      title: "Locomotive Industries",
      short: "Durable, vibration-resistant assemblies for rail applications.",
      image: busduct5,
      description:
        "Supplying robust, vibration-resistant copper and aluminum connectors, assemblies, and busbars designed to withstand the harsh operating conditions of locomotive and rail applications, delivering reliable power transfer and reduced maintenance cycles.",
    },

    {
      title: " Other Electrical Industries",
      short:
        "Tailored copper and aluminum solutions for diverse electrical needs.",
      image: busduct6,
      description:
        "We serve a wide range of electrical industries with custom-engineered copper and aluminum components. Our flexible production capabilities and quality standards support OEMs and contractors with reliable solutions for diverse power systems and control equipment.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Trusted Components & Manufacturing | Delta Engineering</title>
        <meta
          name="description"
          content="Explore Delta Engineering's high-performance copper connectors, silver brazed flexibles, and custom sub-assemblies. Discover our advanced manufacturing capabilities and the industries we serve."
        />
        <meta
          name="keywords"
          content="Delta Engineering, Copper Connectors, Silver Brazed Flexibles, Sub-Assemblies, Press Shop, Flexible Shop, CNC EDM, Power Components, Manufacturing, Switchgear, Busduct, Transformer, EV Connectors"
        />
        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content="Trusted Components & Manufacturing | Delta Engineering"
        />
        <meta
          property="og:description"
          content="Discover premium components and precision manufacturing at Delta Engineering. We serve Switchgear, Transformer, EV, and Locomotive industries with top-tier solutions."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.deltaengnsk.com/products"
        />
        <meta property="og:site_name" content="Delta Engineering" />
        <meta
          name="twitter:title"
          content="Trusted Components - Delta Engineering"
        />
        <meta
          name="twitter:description"
          content="From copper connectors to busbars, explore our complete range of high-performance engineering components and custom solutions."
        />
      </Helmet>

      <section className="facilitybanner-section d-flex align-items-center position-relative">
        <div className="overlay-layer"></div>

        <Container className="text-center position-relative z-2">
          <Row className="w-100 justify-content-center text-center">
            <Col lg={8}>
              <div className="banner2-overlay">
                <h2 className="banner2-title" data-aos="zoom-in" data-aos-delay="300">
  Manufacturing  <span>Facilities</span>
</h2>

                <p
                  className="banner2-subtitle"
                  data-aos="zoom-in"
                  data-aos-delay="200"
                >
                  State of the Art machines
                  <br />
                  Explore our high-performance connectors, flexible assemblies,
                  and power distribution components.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="facilities-section py-3 bg-light pt-2">
        <Container>
          <Row className="text-center mb-4">
            <Col>
              <h3 className="fw-bold text-center section-title">
                Manufacturing Facilities
                <span className="title-underline"></span>
              </h3>
              <p className="text-muted px-3 px-md-5">
                Delta Engineering offers a diverse range of manufacturing
                capabilities with precision, efficiency, and quality assurance.
              </p>
            </Col>
          </Row>
          <Row className="g-4">
            {facilities.map((item) => (
              <Col md={6} lg={4} key={item.id}>
                <Card
                  className="shadow-sm h-100 border-0 rounded-4 position-relative"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleOpen(item)}
                >
                  <Card.Img
                    variant="top"
                    src={item.image}
                    alt={item.title}
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                  <Card.Body className="text-center">
                    <Card.Title className="fw-bold d-flex align-items-center justify-content-center  mb-2">
                      {item.title}
                    </Card.Title>
                    <Card.Text className="text-muted small">
                      {item.short}
                    </Card.Text>
                    <Button
                      variant="primary"
                      size="sm"
                      className="view-more-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOpen(item);
                      }}
                    >
                      View More
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          {selectedItem && (
            <Modal
              show={!!selectedItem}
              onHide={handleClose}
              size="lg"
              centered
              aria-labelledby="facility-modal-title"
              className="facility-modal"
            >
              <Modal.Header closeButton>
                <Modal.Title id="facility-modal-title" className="fw-bold">
                  {selectedItem.title}
                </Modal.Title>
              </Modal.Header>

              <Modal.Body className="py-4 px-4">
                <Row className="align-items-start g-4">
                  <Col md={4} className="text-center">
                    <img
                      src={selectedItem.image}
                      alt={selectedItem.title}
                      className="img-fluid rounded-3 shadow-sm"
                      style={{
                        height: "300px",
                        objectFit: "cover",
                        width: "100%",
                      }}
                    />
                  </Col>
                  <Col md={8}>
                    <h6 className="text-muted fw-semibold mb-3">
                      {selectedItem.short}
                    </h6>
                    <p
                      className="text-muted"
                      style={{ lineHeight: "1.8", textAlign: "justify" }}
                    >
                      {selectedItem.details}
                    </p>
                  </Col>
                </Row>
              </Modal.Body>
            </Modal>
          )}
        </Container>
      </section>

      <section className="py-5 industries-delta-section">
        <Container>
          <Row className="justify-content-center mb-4">
            <h3
              className="fw-bold text-center section-title"
              data-aos="fade-down"
            >
              Industries We Serve
              <span className="title-underline"></span>
            </h3>
            <p className="text-muted text-center" style={{ maxWidth: 700 }}>
              Empowering power infrastructure with specialized components across
              industries.
            </p>
          </Row>

          <Row className="g-4">
            {deltaIndustriesDetails.map((industry, idx) => (
              <Col
                md={4}
                sm={6}
                xs={12}
                key={idx}
                data-aos="fade-up"
                data-aos-delay={idx * 100}
              >
                <Card
                  className="h-100 shadow-lg industry-card"
                  onClick={() => handleOpenModal(industry)}
                  style={{ cursor: "pointer", transition: "transform 0.3s" }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-5px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  <Card.Img
                    variant="top"
                    src={industry.image}
                    className="industry-img"
                  />
                  <Card.Body className="d-flex flex-column">
                    <Card.Title className="fw-bold">
                      {industry.title}
                    </Card.Title>
                    <Card.Text className="text-muted" style={{ flexGrow: 1 }}>
                      {industry.short}
                    </Card.Text>
                    <Button variant="outline-primary" className="mt-auto">
                      Learn More
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
        {selectedIndustry && (
          <Modal
            show={!!selectedIndustry}
            onHide={handleCloseModal}
            centered
            size="lg"
            aria-labelledby="industry-modal-title"
          >
            <Modal.Header closeButton>
              <Modal.Title id="industry-modal-title">
                {selectedIndustry.title}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <img
                src={selectedIndustry.image}
                alt={selectedIndustry.title}
                className="img-fluid mb-3 rounded"
                style={{
                  objectFit: "cover",
                  maxHeight: "300px",
                  width: "100%",
                }}
              />
              <p
                className="text-muted"
                style={{ textAlign: "justify", lineHeight: 1.7 }}
              >
                {selectedIndustry.description}
              </p>
            </Modal.Body>
          </Modal>
        )}
      </section>

      <section className="py-5 bg-light">
        <Container>
          <Row className="text-center mb-4">
            <h3 className="fw-bold section-title position-relative d-inline-block">
              Our Other Services
              <span className="title-underline"></span>
            </h3>
          </Row>
          <Row className="g-4">
            {services.map((service, idx) => (
              <Col lg={4} md={6} key={idx}>
                <Card className="h-100 shadow-sm rounded border-0">
                  <Carousel interval={3000} controls indicators={false} fade>
                    {service.images.map((img, i) => (
                      <Carousel.Item key={i}>
                        <Image
                          src={img}
                          alt={`${service.title} ${i + 1}`}
                          fluid
                          className="w-100"
                          style={{ objectFit: "fill", maxHeight: "400px" }}
                        />
                      </Carousel.Item>
                    ))}
                  </Carousel>

                  <Card.Body className="p-4">
                    <h5 className="fw-bold mb-3" style={{ color: "#003366" }}>
                      {service.title}
                    </h5>

                    <p className="text-muted mb-3">{service.description}</p>

                    <div className="mb-3">
                      <h6 className="fw-semibold">Key Features</h6>
                      <ul className="list-unstyled text-muted">
                        {service.features.map((f, i) => (
                          <li
                            key={i}
                            className="d-flex align-items-center mb-1"
                          >
                            <FaCheckCircle className="me-2 text-success" />
                            {f}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <h6 className="fw-semibold">Application Areas</h6>
                      <ul className="list-unstyled text-muted">
                        {service.applications.map((a, i) => (
                          <li key={i} className="d-flex align-items-start mb-1">
                            <FaCheckCircle className="me-2 mt-1 text-success" />
                            {a}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default FacilitiesPage;
